import safeStringToNumber from './safe-string-to-number.js';
import { isWholeNumber } from './is-whole-number.js';
const numberToUSDFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
const numberToUSDWithoutCentsFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
});
/** Convert cents to USD formatted string */
export const centsToFormattedString = (cents) => {
    let price = safeStringToNumber(cents) / 100;
    if (isNaN(price))
        price = 0;
    return isWholeNumber(price) ? numberToUSDWithoutCentsFormatter.format(price) : numberToUSDFormatter.format(price);
};
export default centsToFormattedString;
//# sourceMappingURL=cents-to-formatted-string.js.map